import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * 自定义 tailwind-merge 配置
 * 解决自定义排版类名 (text-*) 与颜色类名 (text-white) 的冲突问题
 * 默认情况下，tailwind-merge 会将 text-l-medium 识别为文本颜色，从而覆盖 text-white
 */
const customTwMerge = extendTailwindMerge<'glass' | 'font-size'>({
  extend: {
    classGroups: {
      'font-size': [
        'text-xs-regular',
        'text-s-medium',
        'text-m-medium',
        'text-l-medium',
        'text-l-semibold',
        'text-l-bold',
        'text-2xl-medium',
        'text-2xl-semibold',
        'text-2xl-bold',
        'text-3xl-medium',
        'text-3xl-semibold',
        'text-3xl-bold',
        'text-4xl-medium',
        'text-4xl-semibold',
        'text-4xl-bold',
        // 包含其他自定义字号前缀
        {
          text: [
            'xs-regular',
            's-medium',
            'm-medium',
            'l-medium',
            'l-semibold',
            'l-bold',
            '2xl-medium',
            '2xl-semibold',
            '2xl-bold',
            '3xl-medium',
            '3xl-semibold',
            '3xl-bold',
            '4xl-medium',
            '4xl-semibold',
            '4xl-bold',
          ],
        },
        // 装饰性字号
        'deco-s-medium',
        'deco-s-semibold',
        'deco-s-bold',
        // 描述性字号
        'desc-m-medium',
        'desc-m-semibold',
        'desc-m-bold',
        'desc-l-medium',
        'desc-l-semibold',
        'desc-l-bold',
        'desc-2xl-medium',
        'desc-2xl-semibold',
        'desc-2xl-bold',
        'desc-3xl-medium',
        'desc-3xl-semibold',
        'desc-3xl-bold',
      ],
      glass: [
        'glass-core',
        'glass-s30',
        'glass-s60',
        'glass-s-blue',
        'glass-s-purple',
        'glass-m30',
        'glass-m60',
        'glass-l30',
        'glass-l60',
        'glass-xl30',
        'glass-xl60',
        'glass-frosted',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs))
}
